export default {
  UPDATE_USER_INFO(state, payload) {
    state.user = payload;
  },
  profileUpdate(state, payload) {
    state.updatedData = payload;
  },
  UPDATE_USER_COVER_IMAGE(state, payload) {
    state.user.coverImage = payload;
  },
  UPDATE_USER_IMAGE(state, payload) {
    state.user.userImage = payload;
  },
  userData(state, payload) {
    state.userData = payload;
  },
  userCart(state, payload) {
    state.userData.student.cart.push(payload);
  },
  userCartDelete(state, payload) {
    state.userData.student.cart.splice(payload, 1);
  },
  UPDATE_USERDATA_INFO(state, payload) {
    state.userData.student.designation = payload.student.designation;
    state.userData.student.location = payload.student.location;
    state.userData.student.aboutMe = payload.student.aboutMe;
    state.userData.mobile = payload.user.mobile;
    state.userData.email = payload.user.email;
    state.userData.firstname = payload.user.firstname;
    state.userData.lastname = payload.user.lastname;
  },
  logout(state, payload) {
    // console.log("logout");
    state.userData = {};
    state.user = {};
    state.loginAction = {};
    state.signinWith = {};
    state.selectedUser = {};
    state.getUserByUserId = {};
  },
  loginAction(state, payload) {
    state.loginAction = payload;
  },
  signinWith(state, payload) {
    state.signinWith = payload;
  },
  SET_SELECTED_USER(state, payload) {
    state.selectedUser = payload;
  },
  GET_USER_BY_USER_ID(state, payload) {
    state.getUserByUserId = payload;
  },
  SESSION_PRICE(state, payload) {
    state.sessionPrice = payload;
  },
  USER_ROLE(state, payload) {
    state.userRole = payload;
  },
  GET_USER(state, payload) {
    state.getUser = payload;
  },
};
